import React from 'react';
import { useTranslation } from 'react-i18next';
import { images } from '../../components/shared/assets';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import './PressAwardsPage.css';

const PressAwardsPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="press-awards-page">
      {/* Navigation */}
      <SmartNavigation />

      {/* Hero Section */}
      <section className="press-hero" style={{ backgroundImage: `url(${images.atacamaHeroLandscape})` }}>
        <div className="hero-logo">
          <img src={images.logos.awasi} alt="Awasi" />
          <span className="hero-logo-text">ATACAMA</span>
        </div>
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>
              {t('pages/pressAwards:hero.title')}
            </h1>
            <p>
              {t('pages/pressAwards:hero.description')}
            </p>
          </div>
        </div>
      </section>


      {/* Recognition Section */}
      <section className="recognition-section">
        <div className="container">
          <h2>{t('pages/pressAwards:recognition.title')}</h2>
          <div className="awards-list">
            <div className="award-item">
              <div className="award-description">
                <div className="award-property">{t('pages/pressAwards:recognition.awards.0.property')}</div>
                <a href="https://www.telegraph.co.uk/travel/hotels/best-hotels-in-world-telegraph-awards/" target="_blank" rel="noopener noreferrer" className="award-title">
                  {t('pages/pressAwards:recognition.awards.0.title')}
                </a>
              </div>
            </div>
            <div className="award-item">
              <div className="award-description">
                <div className="award-property">{t('pages/pressAwards:recognition.awards.1.property')}</div>
                <a href="https://awasi.com/blog/one-of-awasis-films-awarded-at-international-hollywood-festival/" target="_blank" rel="noopener noreferrer" className="award-title">
                  {t('pages/pressAwards:recognition.awards.1.title')}
                </a>
              </div>
            </div>
            <div className="award-item">
              <div className="award-description">
                <div className="award-property">{t('pages/pressAwards:recognition.awards.2.property')}</div>
                <a href="https://www.cntraveller.com/gallery/best-hotels-in-the-world-2019" target="_blank" rel="noopener noreferrer" className="award-title">
                  {t('pages/pressAwards:recognition.awards.2.title')}
                </a>
              </div>
            </div>
            <div className="award-item">
              <div className="award-description">
                <div className="award-property">{t('pages/pressAwards:recognition.awards.3.property')}</div>
                <a href="https://www.travelandleisure.com/worlds-best/hotels-top-100-overall" target="_blank" rel="noopener noreferrer" className="award-title">
                  {t('pages/pressAwards:recognition.awards.3.title')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Press Grid Section */}
      <section className="press-section">
        <div className="container">
          <h2>{t('pages/pressAwards:press.title')}</h2>
          
          <div className="press-grid">
            {/* Row 1 - Featured Articles */}
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.forbesLogo} alt="Forbes" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  {t('pages/pressAwards:press.articles.forbes.quote')}
                </p>
                <p className="press-meta">{t('pages/pressAwards:press.articles.forbes.meta')}</p>
              </div>
            </div>
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.nationalGeographicLogo} alt="National Geographic" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  {t('pages/pressAwards:press.articles.nationalGeographic.quote')}
                </p>
                <p className="press-meta">{t('pages/pressAwards:press.articles.nationalGeographic.meta')}</p>
              </div>
            </div>
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.timeLogo} alt="Time Magazine" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  {t('pages/pressAwards:press.articles.time.quote')}
                </p>
                <p className="press-meta">{t('pages/pressAwards:press.articles.time.meta')}</p>
              </div>
            </div>
            {/* Row 2 */}
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.cnnLogo} alt="CNN Traveler" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  {t('pages/pressAwards:press.articles.cnn.quote')}
                </p>
                <p className="press-meta">{t('pages/pressAwards:press.articles.cnn.meta')}</p>
              </div>
            </div>
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.mrMrsSmithLogo} alt="Mr & Mrs Smith" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  {t('pages/pressAwards:press.articles.mrMrsSmith.quote')}
                </p>
                <p className="press-meta">{t('pages/pressAwards:press.articles.mrMrsSmith.meta')}</p>
              </div>
            </div>
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.telegraphLogo} alt="The Telegraph" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  The World's 50 Greatest Hotels,<br />
                  Ranked and Rated by Our Experts
                </p>
                <p className="press-meta">AWASI - 2023</p>
              </div>
            </div>
            {/* Row 3 */}
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.travelLeisureLogo} alt="Travel+Leisure" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  Chile Atacama Desert Stargazing<br />
                  at Awasi
                </p>
                <p className="press-meta">AWASI ATACAMA - 2023</p>
              </div>
            </div>
            <div className="press-item">
              <div className="press-logo">
                <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 80' fill='%23333'%3E%3Ctext x='100' y='40' text-anchor='middle' font-family='serif' font-size='18'%3ERobb Report%3C/text%3E%3C/svg%3E" alt="Robb Report" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  Ultimate Adventures:<br />
                  Road Rules
                </p>
                <p className="press-meta">AWASI - 2023</p>
              </div>
            </div>
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.vogueLogo} alt="Vogue" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  Why Solitude is Now the Most<br />
                  Coveted Commodity in Travel
                </p>
                <p className="press-meta">AWASI - 2023</p>
              </div>
            </div>
            {/* Row 4 */}
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.condeNastTravelerLogo} alt="Condé Nast Traveller" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  Gold List:<br />
                  Best Hotels in the World 2019
                </p>
                <p className="press-meta">AWASI ATACAMA - 2019</p>
              </div>
            </div>
            <div className="press-item">
              <div className="press-logo">
                <img src={images.pressAwardsPage.timeLogo} alt="Time Magazine" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  World's Greatest Places 2023:<br />
                  Torres del Paine National Park
                </p>
                <p className="press-meta">AWASI PATAGONIA - 2023</p>
              </div>
            </div>
            <div className="press-item">
              <div className="press-logo">
                <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 80' fill='%23333'%3E%3Ctext x='100' y='40' text-anchor='middle' font-family='serif' font-size='14'%3EHow to Spend It%3C/text%3E%3C/svg%3E" alt="How to Spend It" />
              </div>
              <div className="press-content">
                <p className="press-quote">
                  The World's Most Beautiful<br />
                  Remote Luxury Hotels
                </p>
                <p className="press-meta">AWASI - 2023</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Instagram Section */}
      <InstagramSection 
        title={t('common:instagram.followUs')}
        posts={[
          { src: images.instagram7, alt: "Awasi experience" },
          { src: images.instagram8, alt: "Awasi landscape" },
          { src: images.producingNaturePage.rectangle1488, alt: "Awasi nature" },
          { src: images.instagram4, alt: "Awasi luxury" }
        ]}
      />

      {/* Footer */}
      <Footer variant="default" />
    </div>
  );
};

export default PressAwardsPage;